// extracted by mini-css-extract-plugin
export default {"footerWrapper":"uNplZe","separator":"H9GlOs","container":"QLpbqz","leftSide":"zvP0DA","action":"X_FuTX","rightSide":"hPnLAa"};